import React, { useEffect, useState } from "react";
import UserService from "@/services/api/UserService";

const VdoPlayer = ({ videoId }) => {
  const [otpData, setOtpData] = useState(null);

  const fetchOtp = async () => {
    const data = await UserService.getVdoOtp(videoId);
    if (data) setOtpData(data);
  };

  useEffect(() => {
    fetchOtp();
  }, [videoId]);

  if (!otpData) return <p>Loading video...</p>;
  // console.log("otp data", otpData);
  const src = `https://player.vdocipher.com/v2/?otp=${encodeURIComponent(
    otpData.otp
  )}&playbackInfo=${encodeURIComponent(
    otpData.playbackInfo
  )}&player=${encodeURIComponent("ZFZQTCal7cOiSVk6")}`;

  return (
    <div>
      <iframe
        src={src}
        style={{ border: 0, width: "720px", height: "405px" }}
        allow="encrypted-media"
        allowFullScreen
        title="VdoCipher Video Player"
      />
    </div>
  );
};

export default VdoPlayer;

// 'use client';
// import React, { useEffect, useRef } from 'react';

// const VdoPlayer = ({ otp, playbackInfo }) => {

//     console.log("otp",otp)
//     console.log("playbackInfo",playbackInfo)
//   const containerRef = useRef(null);

//   useEffect(() => {
//     const script = document.createElement('script');
//     script.src = 'https://player.vdocipher.com/playerAssets/1.7.17/vdo.js';
//     script.async = true;

//     script.onload = () => {
//       if (window.vdo) {
//         window.vdo({
//           otp,
//           playbackInfo,
//           theme: "9ae8bbe8dd964ddc9bdb932cca1cb59a",
//           container: containerRef.current,
//         });
//       }
//     };

//     document.body.appendChild(script);

//     return () => {
//       document.body.removeChild(script);
//     };
//   }, [otp, playbackInfo]);

//   return <div ref={containerRef}></div>;
// };

// export default VdoPlayer;
